module.exports = __webpack_public_path__ + "img/icon1.7486172.png";